import * as yup from 'yup'

export const schema = yup.object().shape({
  tipo: yup.string().required('Campo obrigatório não preenchido').typeError('Campo obrigatório não preenchido'),
  idFazenda: yup.string().required('Campo obrigatório não preenchido'),
  dataInicial: yup
    .date()
    .required('Campo obrigatório não preenchido')
    .when('dataFinal', (dataFinal, schema) => {
      const date = dataFinal?.toString() || ''
      if (date.includes('GMT')) {
        return schema.max(dataFinal, 'Data Inicial deve ser menor que a Data Final')
      }
      return schema.required('Campo obrigatório não preenchido')
    })
    .typeError('Campo obrigatório não preenchido'),
  dataFinal: yup.date().required('Campo obrigatório não preenchido').typeError('Campo obrigatório não preenchido')
})

export default schema
